// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- new color definitions from design system */
/* stylelint-disable comment-empty-line-before -- need empty lines for conciseness */
/* IMPORTANT: When changing token values update and convert their -rgb values as well! Vanilla css cannot use rgb(#hex) to convert hex to rgb */
:root {
    /* Greys */
    --ds-color-grey-100: #0f0f10;
    --ds-color-grey-100-rgb: 15 15 16;
    --ds-color-grey-90: #1c1c1f;
    --ds-color-grey-90-rgb: 28 28 31;
    --ds-color-grey-80: #222225;
    --ds-color-grey-80-rgb: 34 34 37;
    --ds-color-grey-70: #28282c;
    --ds-color-grey-70-rgb: 40 40 44;
    --ds-color-grey-60: #2c2c30;
    --ds-color-grey-50: #313136;
    --ds-color-grey-40: #575760;
    --ds-color-grey-30: #62626c;
    --ds-color-grey-20: #9e9ea7;
    --ds-color-grey-20-rgb: 158 158 167;
    --ds-color-grey-10: #eaeaec;
    --ds-color-grey-10-rgb: 234 234 236;

    /* Transparency */
    --ds-alpha-80: 80%;
    --ds-alpha-60: 60%;
    --ds-alpha-40: 40%;
    --ds-alpha-30: 30%;
    --ds-alpha-20: 20%;
    --ds-alpha-15: 15%;
    --ds-alpha-10: 10%;
    --ds-alpha-5: 5%;

    /* Aliases */
    --ds-bg-global: var(--ds-color-grey-100);

    /* Gradients */
    --ds-gradient-color-1: #34314a;
    --ds-gradient-color-2: #1a191e;
    --ds-gradient-1: linear-gradient(
        to bottom,
        var(--ds-gradient-color-1),
        var(--ds-gradient-color-2)
    );

    /* Design system 3.0 colors */
    /* Base */
    --ds-color-charcoal: #181818;
    --ds-color-white: #fff;

    /* Neons */
    --ds-color-neon: #b0fb16;
    --ds-color-neon-0: #e0ff9f;
    --ds-color-neon-0-rgb: 224 255 159;

    /* Indigos */
    --ds-color-indigo-1: #ddd8ff;
    --ds-color-indigo-1-rgb: 221 216 255;
    --ds-color-indigo-2: #9187ff;
    --ds-color-indigo-3: #5e53e0;
    --ds-color-indigo-4: #342862;

    /* Sands */
    --ds-color-sand-1: #f0efe9;
    --ds-color-sand-2: #dad8c4;
    --ds-color-sand-3: #aba28d;
    --ds-color-sand-4: #5e594d;

    /* Oranges */
    --ds-color-orange-1: #ffd5a4;
    --ds-color-orange-2: #ff9517;
    --ds-color-orange-3: #ea6b0e;
    --ds-color-orange-4: #742f1a;

    /* Pinks */
    --ds-color-pink-1: #ffd7ec;
    --ds-color-pink-2: #ff99ce;
    --ds-color-pink-3: #ef5daa;
    --ds-color-pink-4: #54253e;

    /* Grey-indigos */
    --ds-color-grey-indigo-100: #18171c;
    --ds-color-grey-indigo-100-rgb: 24 23 28;
    --ds-color-grey-indigo-90: #212024;
    --ds-color-grey-indigo-80: #28272d;
    --ds-color-grey-indigo-70: #32313b;
    --ds-color-grey-indigo-60: #3a3946;
    --ds-color-grey-indigo-50: #403f4f;
    --ds-color-grey-indigo-40: #484558;
    --ds-color-grey-indigo-40-rgb: 48 45 58;
    --ds-color-grey-indigo-30: #9190a2;
    --ds-color-grey-indigo-20: #c8c7d1;
    --ds-color-grey-indigo-10: #f3f3f5;

    /* Functional colors */
    /* Positive */
    --ds-color-positive: #85ef6b;
    --ds-color-positive-rgb: 133 239 107;
    --ds-color-positive-bg: rgb(
        var(--ds-color-positive-rgb) / var(--ds-alpha-10)
    );
    /* Informative */
    --ds-color-informative: #99c2ff;
    --ds-color-informative-rgb: 153 194 255;
    --ds-color-informative-bg: rgb(
        var(--ds-color-informative-rgb) / var(--ds-alpha-10)
    );
    /* Negative */
    --ds-color-negative: #fc9797;
    --ds-color-negative-rgb: 252 151 151;
    --ds-color-negative-bg: rgb(
        var(--ds-color-negative-rgb) / var(--ds-alpha-10)
    );
    /* Alert */
    --ds-color-alert: #f8ae55;
    --ds-color-alert-rgb: 248 174 85;
    --ds-color-alert-bg: rgb(var(--ds-color-alert-rgb) / var(--ds-alpha-10));

    /* Interaction colors */
    --ds-interaction-hover: var(--ds-color-grey-indigo-50);
    --ds-interaction-select: var(--ds-color-grey-indigo-60);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
